module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title":{"edit":"修改評論","delete":"刪除評論"},"password":{"placeholder":"請輸入寫評論時設定的密碼。","invalid":"密碼不正確。"},"submit":{"edit":"修改評論","delete":"刪除評論"}}}')
  delete Component.options._Ctor
}
